import React from "react"

import classNames from "classnames"

import { Icon } from "shared/ui/icon/Icon"
import { IconName } from "shared/ui/icon/__generated__/IconName"

interface VerifyResultProps {
  remainingAttempts: number | null
  isCodeCorrect: boolean
  validText?: React.ReactNode
  invalidText?: React.ReactNode
}

export const ProfileDeleteCodeVerifyResult = React.memo(
  ({
    remainingAttempts,
    isCodeCorrect,
    validText,
    invalidText
  }: VerifyResultProps) => {
    if (remainingAttempts === null) return null

    return (
      <div
        className={classNames("code-verify-result", {
          "code-verify-result--correct": isCodeCorrect,
          "code-verify-result--incorrect": !isCodeCorrect
        })}
      >
        <div className="code-verify-result__icon">
          <Icon
            name={isCodeCorrect ? IconName.CHECK_CIRCLE : IconName.CLOSE_CIRCLE}
          />
        </div>
        <div className="code-verify-result__text">
          {isCodeCorrect ? validText : invalidText}
        </div>
      </div>
    )
  }
)
